/**TYPES FOR CMS ACTIONS */
export const GET_CMS_SITE_SECONDARY_NAV = "GET_CMS_SITE_SECONDARY_NAV";
export const GET_CMS_SITE_SECONDARY_NAV_ERROR = "GET_CMS_SITE_SEONDARY_NAV_ERROR";